// extracted by mini-css-extract-plugin
export default {"sticker":"sticker--u4VVj"};